const useLanguageAlternates = (siteUrl, pathName) => {
  const path = pathName === '/' ? '' : `${pathName}/`

  return [
    {
      hrefLang: 'en',
      href: `${siteUrl}${path}`,
    },
    {
      hrefLang: 'de',
      href: `${siteUrl}/de${path}`,
    },
    {
      hrefLang: 'es',
      href: `${siteUrl}/es${path}`,
    },
    {
      hrefLang: 'fr',
      href: `${siteUrl}/fr${path}`,
    },
    {
      hrefLang: 'it',
      href: `${siteUrl}/it${path}`,
    },
    {
      hrefLang: 'nl',
      href: `${siteUrl}/nl${path}`,
    },
    {
      hrefLang: 'pl',
      href: `${siteUrl}/pl${path}`,
    },
    {
      hrefLang: 'pt',
      href: `${siteUrl}/pt${path}`,
    },
    {
      hrefLang: 'sr',
      href: `${siteUrl}/sr${path}`,
    },
    {
      hrefLang: 'x-default',
      href: `${siteUrl}${path}`,
    },
  ]
}

export default useLanguageAlternates
